<template>
    <v-dialog v-model="show" max-width="400px">
        <v-card>
            <v-card-title>
                <span class="headline" v-if="isEdited">{{
                    $t("divisions.edit_division")
                }}</span>
                <span class="headline" v-else>{{
                    $t("divisions.add_division")
                }}</span>
            </v-card-title>

            <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="division.name"
                                    :label="$t('divisions.name')"
                                    autofocus
                                    :rules="rules"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="submit">{{
                    $t("general.save")
                }}</v-btn>
                <v-btn @click.stop="show = false">{{
                    $t("general.cancel")
                }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DivisionForm",
    props: {
        form: {
            type: Object,
        },
        division: Object,
        visible: Boolean,
        isEdited: Boolean,
    },

    data() {
        return {
            checkedDefault: true,
            valid: true,
            showEye: false,
            rules: [(value) => !!value || this.$t("general.required")],
            emailRules: [
                (value) => !!value || this.$t("general.required"),
                (value) =>
                    /.+@.+/.test(value) || this.$t("general.email_not_valid"),
            ],
        };
    },

    watch: {
        show(val) {
            !val && this.$refs.form.reset();
        },
    },
    computed: {
        show: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        async submit() {
            if (this.$refs.form.validate()) {
                if (this.isEdited) {
                    await axios
                        .put(
                            `/api/updateDivision/${this.division.id}`,
                            this.division,
                            {
                                headers: {
                                    Authorization:
                                        "Bearer " +
                                        this.$store.state.tokenData.user
                                            .access_token,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.data.isError) {
                                this.$emit(
                                    "snackMessage",
                                    response.data.message,
                                    "warning"
                                );
                                this.$refs.email.focus();
                            } else {
                                // response.data.roleName = response.data.role == "admin" ? "Admin": "Uživatel";
                                this.$emit("updateDivision", response.data);
                                this.$emit(
                                    "snackMessage",
                                    "divisions.division_saved",
                                    "success"
                                );
                                this.$emit("close");
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            this.$emit(
                                "snackMessage",
                                "general.error",
                                "error"
                            );
                        });
                } else {
                    await axios
                        .post(`/api/storeDivision`, this.division, {
                            headers: {
                                Authorization:
                                    "Bearer " +
                                    this.$store.state.tokenData.user
                                        .access_token,
                            },
                        })
                        .then((response) => {
                            if (response.data.isError) {
                                this.$refs.email.focus();
                                this.$emit(
                                    "snackMessage",
                                    response.data.message,
                                    "warning"
                                );
                            } else {
                                this.$emit("addDivision", response.data);
                                this.$emit(
                                    "snackMessage",
                                    "divisions.division_added",
                                    "success"
                                );
                                this.$emit("close");
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            this.$emit(
                                "snackMessage",
                                "general.error",
                                "error"
                            );
                        });
                }
            }
        },
    },
};
</script>
